import React from 'react';
import { Tooltip } from '@mui/material';
import { MdInfo as InfoIcon } from 'react-icons/md';

interface InfoAdornmentProps {
  tooltip: string;
}

const InfoAdornment: React.FC<React.PropsWithChildren<InfoAdornmentProps>> = ({
  tooltip,
}) => {
  return (
    <Tooltip placement='bottom' title={tooltip} arrow>
      <span>
        <InfoIcon
          color='primary'
          fontSize='small'
          style={{ fontSize: 12, cursor: 'pointer' }}
        />
      </span>
    </Tooltip>
  );
};

export default InfoAdornment;
